import { render, staticRenderFns } from "./PurchaseVatRegimeSelect.vue?vue&type=template&id=c2a57046&scoped=true"
import script from "./PurchaseVatRegimeSelect.vue?vue&type=script&lang=ts"
export * from "./PurchaseVatRegimeSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a57046",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2a57046')) {
      api.createRecord('c2a57046', component.options)
    } else {
      api.reload('c2a57046', component.options)
    }
    module.hot.accept("./PurchaseVatRegimeSelect.vue?vue&type=template&id=c2a57046&scoped=true", function () {
      api.rerender('c2a57046', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/PurchaseVatRegimeSelect.vue"
export default component.exports